import axios from 'axios'
import { baseURL } from '@/config/net.config'
import { getToken } from '@/api/auth'

/**
 * 自定义封装axios实例
 */
const request = axios.create({
  baseURL: baseURL, // 设置基础URL
  timeout: 5000 // 超时时间
})

/**
 * 请求拦截器
 */
request.interceptors.request.use(
  (config) => {
    // 在请求发送之前做些什么
    // 可以在这里设置请求头等信息
    config.headers['Token'] = getToken() // 请求头带上token

    return config
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

/**
 * 响应拦截器
 */
request.interceptors.response.use(
  (response) => {
    // 对响应数据做些什么
    return response.data
  },
  (error) => {
    // 对响应错误做些什么
    return Promise.reject(error)
  }
)

export default request
